export default __webpack_public_path__ + "static/media/Epharmacy.a012e5da.webp";